import { FieldError } from 'react-hook-form';
import styled from 'styled-components';

import { Checkbox } from '@creditornot/cb-checkbox';
import { InputContainer, InputContainerProps } from '@creditornot/cb-form';
import { InputAlert } from '@creditornot/cb-input';

const OptionsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const StyledInputAlert = styled(InputAlert)`
  margin-top: 8px;
`;

type Option<Value> = {
  value: Value;
  label: string;
};

type Props<Value> = InputContainerProps & {
  value?: Value[];
  name?: string;
  options: Option<Value>[];
  error?: FieldError;
  onChange?: (value: Value[]) => void;
};

export const CheckboxGroup = <Value extends string>({
  label,
  name,
  hint,
  className,
  style,
  options,
  value = [],
  error,
  onChange,
}: Props<Value>) => {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const input = event.target;
    const inputValue = input.value as Value;

    if (input.checked) {
      onChange?.([...value, inputValue]);
    } else {
      onChange?.(value.filter((v) => v !== inputValue));
    }
  }

  return (
    <InputContainer
      label={label}
      labelHtmlFor={name}
      hint={hint}
      className={className}
      style={style}
    >
      <OptionsList>
        {options.map(({ value: optionValue, label }) => (
          <li key={optionValue}>
            <Checkbox
              name={name}
              value={optionValue}
              checked={value.includes(optionValue)}
              onChange={handleChange}
            >
              {label}
            </Checkbox>
          </li>
        ))}
      </OptionsList>
      {error ? <StyledInputAlert variant="error">{error.message}</StyledInputAlert> : null}
    </InputContainer>
  );
};
